import axios from "axios";
import { Urls } from "../../urls";
import { ServiceUrls } from "../../serviceUrls";

export const getCommonDropdownRepo = (params) => {
    return axios({
        method: "GET",
        baseURL: ServiceUrls.TOOLSHUB_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
        url: Urls.GET_COMMON_DROPDOWN_API,
        params: params,
    });
};


export const getCustomMeanRepo = (params) => {
    return axios({
        method: "GET",
        baseURL: ServiceUrls.TOOLSHUB_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
        url: Urls.CUSTOM_MEAN_API,
        params: params,
    });
};

export const postCustomMeanRepo = (data) => {
    return axios({
        method: "POST",
        baseURL: ServiceUrls.TOOLSHUB_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
        url: Urls.CUSTOM_MEAN_API,
        data: data,
    });
};

export const getFormListRepo = (params) => {
    return axios({
        method: "GET",
        baseURL: ServiceUrls.TOOLSHUB_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
        url: Urls.GET_INPUT_FORM_LIST_API,
        params: params,
    });
};

export const getCreateFormRepo = (params) => {
    return axios({
        method: "GET",
        baseURL: ServiceUrls.TOOLSHUB_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
        url: Urls.CREATE_FORM_API,
        params: params,
    });
};

export const postCreateFormRepo = (data, params) => {
    return axios({
        method: "POST",
        baseURL: ServiceUrls.TOOLSHUB_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
        url: Urls.CREATE_FORM_API,
        data: data,
        params: params
    });
};

export const getExamSessionRepo = (params) => {
    return axios({
        method: "GET",
        baseURL: ServiceUrls.TOOLSHUB_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
        url: Urls.MANAGE_EXAM_SESSION_API,
        params: params,
    });
};

export const postExamSessionRepo = (params) => {
    return axios({
        method: "POST",
        baseURL: ServiceUrls.TOOLSHUB_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
        url: Urls.MANAGE_EXAM_SESSION_API,
        data: params,
    });
};

export const getVariationFactorRepo = (params) => {
    return axios({
        method: "GET",
        baseURL: ServiceUrls.TOOLSHUB_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
        url: Urls.VARIATION_FCTOR_API,
        params: params,
    });
};

export const postVariationFactorRepo = (params) => {
    return axios({

        method: "POST",
        baseURL: ServiceUrls.TOOLSHUB_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
        url: Urls.VARIATION_FCTOR_API,
        data: params,
    });
};

export const getFlowTypeRepo = (params) => {
    return axios({
        method: "GET",
        baseURL: ServiceUrls.TOOLSHUB_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
        url: Urls.MANAGE_IO_FLOW_TYPE_API,
        params: params,
    });
};

export const postFlowTypeRepo = (data) => {
    return axios({
        method: "POST",
        baseURL: ServiceUrls.TOOLSHUB_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
        url: Urls.MANAGE_IO_FLOW_TYPE_API,
        data: data,
    });
};

export const delFlowTypeRepo = (data) => {
    return axios({
        method: "DELETE",
        baseURL: ServiceUrls.TOOLSHUB_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
        url: Urls.MANAGE_IO_FLOW_TYPE_API,
        data: data,
    });
};

export const getAppearedStudentsRepo = (params) => {
    return axios({
        method: "GET",
        baseURL: ServiceUrls.TOOLSHUB_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
        url: Urls.APPEARED_STUDENTS_API,
        params: params,
    });
};

export const postAppearedStudentsRepo = (data) => {
    return axios({
        method: "POST",
        baseURL: ServiceUrls.TOOLSHUB_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
        url: Urls.APPEARED_STUDENTS_API,
        data: data,
    });
};
export const getCreateFormInputFieldMappingRepo = (params) => {
    return axios({
        method: "GET",
        baseURL: ServiceUrls.TOOLSHUB_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
        url: Urls.CREATE_FORM_DETAIL_API,
        params: params,
    });
}
export const postCreateFormInputFieldMappingRepo = (data) => {
    return axios({
        method: "POST",
        baseURL: ServiceUrls.TOOLSHUB_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
        url: Urls.CREATE_FORM_DETAIL_API,
        data: data,
    });
}

//RP Merit List
export const getRPMeritListRepo = (params) => {
    return axios({
        method: "GET",
        baseURL: ServiceUrls.TOOLSHUB_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
        url: Urls.RP_MERIT_LIST_API,
        params: params,
    });
};
export const postRPMeritListRepo = (data) => {
    return axios({
        method: "POST",
        baseURL: ServiceUrls.TOOLSHUB_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
        url: Urls.RP_MERIT_LIST_API,
        data: data,
    });
};
export const postMeritListValidationCheckRepo = (data) => {
    return axios({
        method: "POST",
        baseURL: ServiceUrls.TOOLSHUB_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
        url: Urls.MERIT_LIST_VALIDATION_CHECK_API,
        data: data,
    });
};
export const postUploadMeriListRepo = (data) => {
    return axios({
        method: "POST",
        baseURL: ServiceUrls.TOOLSHUB_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
        url: Urls.UPLOAD_MERIT_LIST_API,
        data: data,
        timeout: 20000,
    });
};

export const getDetailFlowTypeRepo = (params) => {
    return axios({
        method: "GET",
        baseURL: ServiceUrls.TOOLSHUB_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
        url: Urls.GET_DETAIL_INPUT_API,
        params: params,
    });
};
export const getRPUsageListRepo = (params) => {
    return axios({
        method: "GET",
        baseURL: ServiceUrls.TOOLSHUB_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
        url: Urls.RP_USAGE_LIST_API,
        params: params,
    });
};

export const getRPUsageAnalyticsRepo = (params) => {
    return axios({
        method: "GET",
        baseURL: ServiceUrls.TOOLSHUB_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
        url: Urls.RP_USAGE_ANALYTICS_API,
        params: params,
    });
};

export const getCreateFormDetailRepo = (params) => {
    return axios({
        method: "GET",
        baseURL: ServiceUrls.TOOLSHUB_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
        url: Urls.CREATE_FORM_DETAIL_API,
        params: params,
    });
}
export const postCreateFormDetailRepo = (data) => {
    return axios({
        method: "POST",
        baseURL: ServiceUrls.TOOLSHUB_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
        url: Urls.CREATE_FORM_DETAIL_API,
        data: data,
    });
}

